<template>
    <div class="card order-success__meta">
        <ul class="order-success__meta-list">
            <li class="order-success__meta-item">
                <span class="order-success__meta-title">Order number:</span>
                <span class="order-success__meta-value" v-for="order_no in uniqueOrderNos" :key="order_no">#{{order_no}}</span>
            </li>
            <li class="order-success__meta-item">
                <span class="order-success__meta-title">Created:</span>
                <span class="order-success__meta-value">{{ordered_summary.created_date}}</span>
            </li>
            <li class="order-success__meta-item">
                <span class="order-success__meta-title">Total:</span>
                <span class="order-success__meta-value notranslate">{{toUSD(ordered_summary.grandtotal)}}</span>
            </li>
        </ul>
    </div>

    <div class="card">
        <div class="order-list">
            <table>
                <location-items v-for="location in uniqueLocations" :key="location"
                :currentlocationid="location"
                :name="shippingname"
                :order_number="ordered_summary.order_number">
                </location-items>

                <tbody class="order-list__subtotals">
                    <tr class="order-list__subtotals">
                        <th class="order-list__column-label" colspan="3">Subtotal</th>
                        <td class="order-list__column-total notranslate">{{toUSD(ordered_summary.subtotal)}}</td>
                    </tr>

                    <tr class="order-list__subtotals" v-if="ordered_summary.core_changes > 0">
                        <th class="order-list__column-label" colspan="3">Core Charges</th>
                        <td class="order-list__column-total notranslate">{{toUSD(ordered_summary.core_changes)}}</td>
                    </tr>
                    <tr v-if="ordered_summary.discounttotal > 0">
                        <th class="order-list__column-label" colspan="3">Promotional Discount</th>
                        <td class="order-list__column-total notranslate"> -{{toUSD(ordered_summary.discounttotal)}}</td>
                    </tr>
                    <tr class="order-list__subtotals" v-if="ordered_summary.tax > 0">
                        <th class="order-list__column-label" colspan="3">Tax</th>
                        <td class="order-list__column-total notranslate">{{toUSD(ordered_summary.tax)}}</td>
                    </tr>

                    <tr class="order-list__subtotals"  v-if="ordered_summary.shipping > 0">
                        <th class="order-list__column-label" colspan="3">Shipping</th>
                        <td class="order-list__column-total notranslate">{{toUSD(ordered_summary.shipping)}}</td>
                    </tr>
                </tbody>
                <tfoot class="order-list__footer">
                    <tr>
                        <th class="order-list__column-label" colspan="3">Total</th>
                        <td class="order-list__column-total notranslate">{{toUSD(ordered_summary.grandtotal)}}</td>
                    </tr>
                    <tr v-if="payment_type == 'CC'">
                        <th class="order-list__column-label" colspan="2">Payment Method:</th>
                        <td class="order-list__column-total" colspan="2">Credit Card</td>
                    </tr>
                    <tr v-if="purchaseorder != ''">
                        <th class="order-list__column-label" colspan="2">Purchase Order:</th>
                        <td class="order-list__column-total" colspan="2">{{purchaseorder}}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>

    <div class="block-space--layout--divider-20"></div>

    <div class="card" v-if="backorders.length > 0">
        <div class="order-list">
            <table>								
                <tr class="cart-locations-row">				
                    <td colspan="7" class="cart-locations">Backordered Items</td>
                </tr>
                    <tr class="order-list__header">
                        <th class="order-list__column-label" colspan="2">Product</th>
                        <th class="order-list__column-quantity">Quantity</th>
                        <th class="order-list__column-total">Total</th>
                    </tr>
                    <tr v-for="(border, i) in backorders" :key="i">
                        <td class="order-list__column-image">
                            <div class="image image--type--product">
                                <router-link to="border.url" class="image__body">
                                    <img class="image__tag" :src="border.image" :alt="border.product_name">
                                </router-link>
                            </div>
                        </td>
                        <td class="order-list__column-product">
                        </td>
                        <td class="order-list__column-quantity" data-title="Quantity:">
                            {{ border.bo_quantity }}
                        </td>
                        <td class="order-list__column-total">{{toUSD( border.bo_quantity * border.price)}}</td>
                    </tr>
            </table>
            
        </div>
    </div>
</template>

<script>
import Price from '../../../mixins/price.js';
import LocationItems from './LocationItems.vue'
import { mapGetters } from 'vuex';

export default {
    mixins: [
        Price
    ],
    props: {
        ordered_summary: {
            type: Object
        }
    },

    components : {
        LocationItems
    },

    computed: {
        ...mapGetters([
            'getDefaultLocationDetails'
        ]),
        ...mapGetters('cart', [
            'ordered_items',
            'backordered_items'
        ]),
        uniqueLocations() {
            let uniques = [... new Set(this.ordered_items.map((item) => 
                item.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : item.locationid
            ))];
            uniques.sort((a,b) => (a > b) ? 1 : ((b > a) ? -1 : 0));
            return uniques;
        },

        uniqueOrderNos() {
            let uniques = [... new Set(this.ordered_items.map((item) => 
                item.ord_number
            ))];
            uniques.sort((a,b) => (a > b) ? 1 : ((b > a) ? -1 : 0));
            return uniques;
        },

        backorders() {
            const bords = this.ordered_items.filter((item) => {
                // console.log(item);
                if (item.bo_quantity > 0){
                    return true;
                }
            });
            console.log(bords);
            return bords;
        },
        payment_type() {
            console.log('payment type = ' + this.$store.getters['cart/paymenttype']);
            return this.$store.getters['cart/paymenttype'];
        },
        purchaseorder() {
            return this.$store.getters['cart/purchaseorder'];
        }
    },

    created() {
        // this.ordered_items = this.$store.getters['cart/ordered_items'];
        // console.log(this.ordered_items);
        // console.log(this.getDefaultLocationDetails);
        // console.log(this.ordered_items);
        // console.log(this.ordered_summary);
    }
}
</script>